import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Card, Divider, Text } from "@nextui-org/react";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import * as Yup from "yup";
import { formatDatesWithCurrent, noop } from "../../../helpers";
import { Checkbox, DateRangeWithCurrent, Input, TextList } from "../../controls/formik-wrapped";
import { List } from "./list";
var DEFAULT_VALUE = {
  company: "",
  title: "",
  company_full: "",
  location: "",
  title_full: "",
  dates: "",
  date_range: [],
  is_current: false,
  extended_details: "",
  quick_details: "",
  details: [],
  accomplishments: [],
  skills: [],
  skills_used: [],
  other_roles: [],
  previous: false,
  overflow: false,
  omit: false
};
var KEYS = Object.freeze(Object.keys(DEFAULT_VALUE));

var compareValues = function compareValues(a, b) {
  if (a === b || !a || !b) return true;
  var matches = KEYS.reduce(function (matched, key) {
    return matched && a[key] === b[key];
  }, true);
  return matches;
};

var aggregateErrors = function aggregateErrors(errors) {
  return Object.values(errors).reduce(function (errs, err) {
    return err ? [].concat(_toConsumableArray(errs), [err]) : errs;
  }, []);
};

var SingleWorkExperience = function SingleWorkExperience(_ref) {
  var initialValue = _ref.initialValue,
      onValueChanged = _ref.onValueChanged,
      setValidateFunction = _ref.setValidateFunction;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      validReason = _useState6[0],
      setValidReason = _useState6[1];

  var previousValue = useRef(initialValue);
  var validationSchema = useMemo(function () {
    var schema = Yup.object({
      company: Yup.string().ensure().trim().required(),
      title: Yup.string().ensure().trim().required(),
      location: Yup.string().ensure().trim().required(),
      date_range: Yup.array().ensure().length(2),
      is_current: Yup.bool(),
      quick_details: Yup.string().ensure(),
      details: Yup.array().ensure(),
      accomplishments: Yup.array().of(Yup.string()),
      skills: Yup.array().ensure(),
      skills_used: Yup.array().ensure(),
      other_roles: Yup.array().ensure(),
      previous: Yup.bool(),
      overflow: Yup.bool(),
      omit: Yup.bool()
    });
    return schema;
  }, []);
  useEffect(function () {
    if (isValid === undefined) return;
    if (compareValues(previousValue.current, currentValue)) return;
    previousValue.current = currentValue;

    if (isValid) {
      onValueChanged(currentValue);
    }
  }, [currentValue, isValid, onValueChanged, validReason]);
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValue !== null && initialValue !== void 0 ? initialValue : _objectSpread({}, DEFAULT_VALUE),
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: function onSubmit(_values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setSubmitting(false);
    }
  }, function (_ref3) {
    var isValid = _ref3.isValid,
        values = _ref3.values,
        errors = _ref3.errors,
        validateForm = _ref3.validateForm;
    setValidateFunction === null || setValidateFunction === void 0 ? void 0 : setValidateFunction(validateForm);
    setIsValid(isValid);
    if (isValid && !compareValues(currentValue, values)) setCurrentValue(values);
    var aggregatedErrors = aggregateErrors(errors);
    setValidReason(aggregatedErrors.length ? aggregatedErrors.join("; ") : undefined);
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
      label: "Company",
      name: "company",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "company",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Title",
      name: "title",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "title",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input, {
      label: "Location",
      name: "location",
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "location",
      component: "div"
    }), /*#__PURE__*/React.createElement(DateRangeWithCurrent, null), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "date_range",
      component: "div"
    }), /*#__PURE__*/React.createElement(Input.Textarea, {
      label: "Summary",
      name: "quick_details",
      fullWidth: true
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "quick_details",
      component: "div"
    }), /*#__PURE__*/React.createElement(TextList, {
      label: "Accomplishments",
      name: "accomplishments"
    }), /*#__PURE__*/React.createElement(ErrorMessage, {
      name: "accomplishments",
      component: "div"
    }), /*#__PURE__*/React.createElement(Checkbox, {
      label: "Don't show this entry",
      name: "omit"
    }));
  });
};

var DisplaySingleWorkExperience = function DisplaySingleWorkExperience(_ref4) {
  var initialValue = _ref4.initialValue;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.company) || "Unspecified Employer"), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Text, {
    size: "sm"
  }, initialValue === null || initialValue === void 0 ? void 0 : initialValue.title), /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, formatDatesWithCurrent(initialValue)), /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, initialValue === null || initialValue === void 0 ? void 0 : initialValue.location)));
};

var EditSingleWorkExperienceHeader = function EditSingleWorkExperienceHeader(_ref5) {
  var initialValue = _ref5.initialValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, (initialValue === null || initialValue === void 0 ? void 0 : initialValue.company) || "Work Experience"), /*#__PURE__*/React.createElement(Text, {
    size: "xs"
  }, initialValue === null || initialValue === void 0 ? void 0 : initialValue.title));
};

export var WorkExperienceEditor = function WorkExperienceEditor(_ref6) {
  var work_experience = _ref6.work_experience,
      onValueChanged = _ref6.onValueChanged;
  return /*#__PURE__*/React.createElement(List, {
    individuallyEdit: true,
    display: DisplaySingleWorkExperience,
    editHeader: EditSingleWorkExperienceHeader,
    input: SingleWorkExperience,
    newItem: function newItem() {
      return _objectSpread({}, DEFAULT_VALUE);
    },
    values: work_experience || [],
    onValueAdded: noop,
    onValueChanged: noop,
    onValuesChanged: onValueChanged
  });
};